import { Immutable } from "immer";
import React from "react";
import { ReviewsComponentTypes } from "tsi-common-react/src/apps/reviews/constants";
import { ReviewsFullBlock } from "tsi-common-react/src/components/ReviewsFullBlock/index";

import { templates } from "@reactivated";

// Flavor props mirror this site's ProductReviewsTemplate.tsx -- the island the
// legacy `{% react_product_reviews %}` tag mounted for this block.
export const Template = (
    props: Immutable<templates.ReviewsFullBlockTemplate>,
): React.JSX.Element => {
    return (
        <ReviewsFullBlock
            value={props.value}
            starHasStroke={true}
            reviewsComponentType={ReviewsComponentTypes.CAROUSEL}
            showWriteReviewButton={false}
        />
    );
};
